import React from 'react';
import lwaIcon from '../assets/lwa.svg';
import {
  Badge,
  Button,
  ExpandableSection,
  Header,
  Icon,
  SpaceBetween,
  TextContent,
} from '@amzn/awsui-components-react';
import { IdPs } from '../constants/providers';
import { useIntl } from 'react-intl';
import { providerMessages } from '../i18n/provider.messages';
import styles from './ProviderButton.module.css';

import lwaSunsetPhaseMessages from '../i18n/lwaSunsetPhase.messages';
import { AppConfig } from '../types/app';
import signinMessages from '../i18n/signin.messages';
import { useHistory } from 'react-router-dom';
import { AppURL } from '../constants/urls';
import { publishAuthMetrics } from '../utils/publishLwaSunsetMetrics';
import { parseToUTCDate } from '../utils/parseToUTCDate';

const LwaProviderButton = ({ config }: { config: AppConfig }): JSX.Element => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  return (
    <>
      <div className={styles.idpBox_last}>
        <ExpandableSection
          variant="footer"
          headerText={
            <SpaceBetween direction="horizontal" size="xs">
              {lwaIcon && (
                <div className={[styles.lwa].join('')}>
                  <Icon
                    size="big"
                    url={lwaIcon}
                    alt={formatMessage(providerMessages[IdPs.LoginWithAmazon])}
                  />
                </div>
              )}
              <Header
                id={`${IdPs.LoginWithAmazon}-providerLabel`}
                data-testid="signin-providerLabel"
                variant="awsui-h1-sticky"
              >
                {formatMessage(providerMessages[IdPs.LoginWithAmazon])}
              </Header>
              <div className={styles.lwaBadge}>
                <Badge color="grey">
                  <Icon name="status-warning" alt="warning icon" />{' '}
                  {formatMessage(lwaSunsetPhaseMessages.unavailableBadge, {
                    date: parseToUTCDate(config.lwaDeprecationDate),
                  })}
                </Badge>
              </div>
            </SpaceBetween>
          }
          id="lwa-expander"
        >
          <div className={[styles.rowElements].join(' ')}>
            <TextContent>
              <p>
                {formatMessage(lwaSunsetPhaseMessages.lwaIdpDescription, {
                  b: (str) => <b>{str}</b>,
                })}
              </p>
            </TextContent>
            <div className={styles.siginInButtonWithDescription}>
              <Button
                wrapText={false}
                onClick={(e) => {
                  e.preventDefault();
                  publishAuthMetrics(
                    IdPs.LoginWithAmazon,
                    'LwaPreAuth',
                    `${IdPs.LoginWithAmazon}-provider-button`
                  );
                  const urlParams = new URLSearchParams(window.location.search);
                  history.push({
                    pathname: AppURL.LwaSignInWarning,
                    search: urlParams.toString(),
                  });
                }}
                data-testid={`${IdPs.LoginWithAmazon}-provider-button`}
                id={`${IdPs.LoginWithAmazon}-provider-button`}
                ariaLabel={IdPs.LoginWithAmazon}
              >
                {formatMessage(signinMessages.signinButton)}
              </Button>
            </div>
          </div>
        </ExpandableSection>
      </div>
    </>
  );
};

export default LwaProviderButton;
